export default "__VITE_ASSET__BsDuPBxW__"